///thirdpartypricing/list
export const MASTER_THIRD_PARTY_PRICING_LIST = "MASTER_THIRD_PARTY_PRICING_LIST";
export const MASTER_THIRD_PARTY_PRICING_LIST_SUCCESS =
  "MASTER_THIRD_PARTY_PRICING_LIST_SUCCESS";
export const MASTER_THIRD_PARTY_PRICING_LIST_FAILURE =
  "MASTER_THIRD_PARTY_PRICING_LIST_FAILURE";
///thirdpartypricing/create
export const MASTER_THIRD_PARTY_PRICING_CREATE = "MASTER_THIRD_PARTY_PRICING_CREATE";
export const MASTER_THIRD_PARTY_PRICING_CREATE_SUCCESS =
  "MASTER_THIRD_PARTY_PRICING_CREATE_SUCCESS";
export const MASTER_THIRD_PARTY_PRICING_CREATE_FAILURE =
  "MASTER_THIRD_PARTY_PRICING_CREATE_FAILURE";
///thirdpartypricing/update
export const MASTER_THIRD_PARTY_PRICING_UPDATE = "MASTER_THIRD_PARTY_PRICING_UPDATE";
export const MASTER_THIRD_PARTY_PRICING_UPDATE_SUCCESS =
  "MASTER_THIRD_PARTY_PRICING_UPDATE_SUCCESS";
export const MASTER_THIRD_PARTY_PRICING_UPDATE_FAILURE =
  "MASTER_THIRD_PARTY_PRICING_UPDATE_FAILURE";
///thirdpartypricing/delete
export const MASTER_THIRD_PARTY_PRICING_DELETE = "MASTER_THIRD_PARTY_PRICING_DELETE";
export const MASTER_THIRD_PARTY_PRICING_DELETE_SUCCESS =
  "MASTER_THIRD_PARTY_PRICING_DELETE_SUCCESS";
export const MASTER_THIRD_PARTY_PRICING_DELETE_FAILURE =
  "MASTER_THIRD_PARTY_PRICING_DELETE_FAILURE";